import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { BodyText } from '@calendly/ui/components/typography';
import type { ReactNode } from 'react';
import { useDispatch } from 'react-redux';
import CalendarImgSrc from 'features/meetings/images/calendar.svg';
import { BOOKING_METHODS, openModal as openOneOffModal } from 'features/one_off_modal';
import { useScope } from 'hooks/meetings/use_scope';
import { useGetScopeInfoQuery } from 'shared/api/meetings';
type ResolvedScopeType = 'my_calendly' | 'user_single' | 'all_users' | 'page_single' | 'page' | 'all_users_and_teams' | 'user_group' | null;
const getScopeType = (type: string | null | undefined, id: string | null | undefined): ResolvedScopeType => {
  if (type === 'user') {
    if (id === 'me') return 'my_calendly';
    if (id) return 'user_single';
    return 'all_users';
  }
  if (type === 'team') return id ? 'page_single' : 'page';
  if (type === 'all_users_and_teams') return 'all_users_and_teams';
  if (type === 'all_users') return 'all_users';
  if (type === 'user_group') return 'user_group';
  return null;
};
const noUpcomingContainerCss = "n1cm60qk";
const descriptionWrapperCss = "d3olj9z";
const buttonWrapperCss = "bmu574v";
type BaseCardProps = {
  description: ReactNode;
  ctaButton?: ReactNode;
};
const BaseCard = ({
  description,
  ctaButton
}: BaseCardProps) => <div className={noUpcomingContainerCss}>
    <img src={CalendarImgSrc} alt="Calendar" width="80" height="80" />
    <BodyText weight="bold">{I18n.t('publisher.meetings.end_of_list.no_upcoming_meetings')}</BodyText>
    <BodyText size="medium" color="muted">
      <span className={descriptionWrapperCss}>
        {description}
      </span>
    </BodyText>
    {ctaButton}
  </div>;
export const NoUpcomingMeetingsCard = () => {
  const dispatch = useDispatch();
  const {
    scopeId,
    scopeType: listedType
  } = useScope();
  const scopeType = getScopeType(listedType, scopeId);
  const {
    data,
    isLoading
  } = useGetScopeInfoQuery({
    scopeId,
    scopeType
  });
  if (isLoading) return null;
  let description: ReactNode;
  if (scopeType === 'my_calendly') {
    description = I18n.t('publisher.meetings.end_of_list.we_can_change_that');
  } else if (scopeType === 'user_single' || scopeType === 'page_single') {
    description = I18n.t('publisher.meetings.end_of_list.named', {
      name: data?.currentScope
    });
  } else if (scopeType === 'page') {
    description = I18n.t('publisher.meetings.end_of_list.teams');
  } else {
    description = I18n.t('publisher.meetings.end_of_list.users');
  }
  const ctaButton = scopeType === 'my_calendly' ? <div className={buttonWrapperCss}>
      <Button decoration="secondary-outline" onClick={() => dispatch(openOneOffModal({
      bookingMethod: BOOKING_METHODS.instant
    }))}>
        {I18n.t('publisher.meetings.empty_state.schedule_meeting')}
      </Button>
    </div> : undefined;
  return <BaseCard description={description} ctaButton={ctaButton} />;
};

require("./NoUpcomingMeetingsCard.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./NoUpcomingMeetingsCard.tsx");